import HomeSmileIcon from 'src/icons/untitled-ui/duocolor/home-smile';

export const sellerSections = (t, tokens, paths, SvgIcon) => {
  // Dynamic section for seller
  return [
    {
      items: [
        {
          title: t(tokens.nav.students),
          path: paths.dashboard.index,
          icon: (
            <SvgIcon fontSize="small">
              <HomeSmileIcon />
            </SvgIcon>
          ),
        },
      ],
    },
  ];
};
